import { useState } from 'react';
import type { Media } from '@wineryxplorer/shared';
import { trpc } from '../../lib/trpc';
import { ImageModal } from '../ui/ImageModal';
import { ImgWithSkeleton } from '../ui/ImgWithSkeleton';

// Component to fetch and display review photos with fullscreen modal
export const ReviewPhotos = ({ imageIds }: { imageIds: string[] }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);

  const { data: mediaList } = trpc.media.getByIds.useQuery(
    { ids: imageIds },
    { enabled: imageIds.length > 0 }
  );

  if (!mediaList || mediaList.length === 0) {
    return null;
  }

  const handleImageClick = (index: number) => {
    setSelectedImageIndex(index);
    setModalOpen(true);
  };

  return (
    <div className="mb-4">
      <div className="flex flex-wrap gap-2">
        {mediaList.map((media: any, index: number) => (
          <button
            key={media.id}
            type="button"
            onClick={() => handleImageClick(index)}
            className="w-20 h-20 bg-gray-100 rounded-lg overflow-hidden cursor-pointer focus:outline-none focus:ring-2 focus:ring-info-500 focus:ring-offset-2"
          >
            <ImgWithSkeleton
              src={media.cloudinaryUrl}
              alt={media.caption || 'Review photo'}
              className="w-full h-full object-cover hover:scale-105 transition-transform duration-200"
              skeletonClassName="rounded-lg"
            />
          </button>
        ))}
      </div>

      <ImageModal
        images={mediaList as Media[]}
        initialIndex={selectedImageIndex}
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
      />
    </div>
  );
};
